export const WAEC_ECONOMICS = [
  {
    q: "The basic economic problem is:",
    o: ["Inflation", "Scarcity", "Unemployment", "Poverty"],
    a: 1,
    e: "Scarcity — unlimited wants vs limited resources — is the fundamental economic problem.",
    h: "Why do we have to make choices?",
    yr: "2023",
  },
  {
    q: "When the price of a good rises and demand falls, this is known as:",
    o: ["Elastic demand", "Inelastic demand", "The law of demand", "The law of supply"],
    a: 2,
    e: "The law of demand states that as price rises, quantity demanded falls, ceteris paribus.",
    h: "Basic demand principle.",
    yr: "2022",
  },
  {
    q: "GDP stands for:",
    o: ["Gross Domestic Product", "General Domestic Profit", "Gross Demand Price", "General Demand Policy"],
    a: 0,
    e: "GDP = Gross Domestic Product. It measures the total monetary value of all goods and services produced in a country in a year.",
    h: "A measure of a country's economy.",
    yr: "2023",
  },
  {
    q: "A monopoly exists when there is:",
    o: ["Many sellers, one buyer", "One seller, many buyers", "Two sellers in a market", "Perfect competition"],
    a: 1,
    e: "A monopoly is a market structure with a single seller supplying the entire market.",
    h: "Mono = one.",
    yr: "2021",
  },
  {
    q: "Inflation means:",
    o: ["Fall in price level", "Rise in unemployment", "Persistent rise in general price level", "Increase in GDP"],
    a: 2,
    e: "Inflation is a sustained increase in the general price level of goods and services over time.",
    h: "Your money buys less over time.",
    yr: "2022",
  },
];

export const WAEC_ECONOMICS_LEARN = [
  {
    topic: "Demand & Supply",
    content: "Demand: quantity buyers are willing and able to buy at various prices. Supply: quantity sellers are willing and able to sell. Equilibrium: where demand = supply. Demand shifters: income, tastes, prices of related goods, expectations. Supply shifters: input costs, technology, number of sellers.",
  },
  {
    topic: "Market Structures",
    content: "Perfect competition: many buyers/sellers, identical products, free entry/exit. Monopoly: one seller, barriers to entry, price maker. Monopolistic competition: many sellers, differentiated products. Oligopoly: few large firms, interdependence, e.g. telecoms, airlines.",
  },
  {
    topic: "National Income",
    content: "GDP = C + I + G + (X–M). C = Consumption, I = Investment, G = Government spending, X = Exports, M = Imports. GNP = GDP + net income from abroad. Real GDP adjusts for inflation. GDP per capita = GDP ÷ population.",
  },
  {
    topic: "Money & Banking",
    content: "Functions of money: medium of exchange, store of value, unit of account, standard of deferred payment. Central bank controls monetary policy: interest rates, reserve requirements, open market operations. Commercial banks create money through the credit multiplier.",
  },
  {
    topic: "International Trade",
    content: "Comparative advantage: produce what you can make at lower opportunity cost. Trade benefits both parties. Balance of payments = current account + capital account + financial account. Tariffs, quotas, and subsidies are protectionist tools. WTO promotes free trade.",
  },
];
